import React, {useEffect, useState} from "react";
import {Form} from "react-bootstrap";
import {Controller, useForm} from "react-hook-form";
import {useNavigate} from "react-router";
import ThemeButton from "../../../../components/common/theme-button/ThemeButton";
import {maxLength, PasswordValidation, Required,} from "../../../../utils/patterns";
import {RoundedCheck} from "../../../../../assets/icons/defaultIcons";
import {notification} from "antd";
import PasswordInput from "../../../../components/common/password-field/PasswordInput";
import {UserAuthService} from "../../../../services/user-auth-api.service";
import {useJournal} from "../../../../providers/JournalContext";

export default function ValidateJournalPassword({
  close,
  getListing,
  setGetListing,
}) {
  const [loader, setLoader] = useState(false);
  const { setUpdateJournalProfile, updateJournalProfile } = useJournal();
  const {
    validateJournalPass,
    setValidateJournalPass,
    firstTimePassword,
    userEmail,
    setVerifyJournalOtp,
    verifyJournalOtp,
  } = useJournal();
  const {
    handleSubmit,
    reset,
    setValue,
    formState: { errors, isValid },
    control,
    clearErrors,
  } = useForm({
    mode: "onChange",
  });
  const navigate = useNavigate();

  const onSubmit = async (data) => {
    setLoader(true);

    if (data) {
      let payload = {
        password: data.password,
      };
      const response = await UserAuthService.ValidateJournalPassword(payload);

      if (response?.data?.data?.status) {
        notification.success({
          message: "Success",
          description: response.data?.data?.message,
          placement: "topRight",
          icon: <RoundedCheck />,
          duration: 2,
        });
        setValidateJournalPass(false);
        setLoader(false);
        navigate("/journals");
      }
      setLoader(false);
      // else{
      //     notification.error({
      //         message: "Failed",
      //         description: response.data?.data?.message,
      //         placement: "topRight",
      //         icon: <CloseRoundedCheck/>,
      //         duration: 2,
      //     });
      //     setLoader(false)
      // }
    }
  };

  useEffect(() => {
    // if (firstTimePassword === true) {
    //   navigate("/journals/set-journal-password");
    // }
     if (validateJournalPass === true) {
      navigate("/journals/validate-password");
    }
  }, [firstTimePassword, validateJournalPass]);

  const ResetPasswordFun = async () => {
    setLoader(true);
    const result = await UserAuthService.ForgetPasswordApi(userEmail);
    if (result?.data?.data?.status) {
      notification.success({
        message: "Success",
        description: `${result?.data?.data?.message}`,
        placement: "topRight",
        icon: <RoundedCheck />,
        duration: 2,
      });
      setVerifyJournalOtp(false);
      navigate("/journals/journal-otp-screen", { state: { email: userEmail } });
    }
    setLoader(false);
  };

  return (
    <div className={"align-content-center h-100"}>
      <div className={"validate-journals"}>
        <h3>Enter journal Password</h3>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className={"dfields"}>
            <Controller
              name="password"
              defaultValue={""}
              control={control}
              rules={{
                required: Required,
                pattern: PasswordValidation,
                maxLength: maxLength(100),
              }}
              render={({ field: { name, ...field } }) => (
                <PasswordInput
                  placeholder={"Your password here"}
                  label={"Password"}
                  field={field}
                  errors={errors.password}
                  className={"required"}
                />
              )}
            />
          </div>
          <div className={"mt-30 mb-30"}>
            <ThemeButton
              text={"Proceed"}
              type={"submit"}
              className={"btn-light-lg"}
              loader={loader}
            />
          </div>
          {/*<p className={'forget-pass'} onClick={()=>{ ResetPasswordFun()}}>Forgot Password?</p>*/}
        </Form>
      </div>
    </div>
  );
}
